import { mapGetters } from 'vuex'
import { isNil } from 'lodash'

export default {
  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage'
    }),
    walletEnabled() {
      if (isNil(this.currentManage)) return false
      const { subproperty } = this.currentManage
      if (isNil(subproperty)) return false
      const { paymentsEnabled, owqloFeeFixed, owqloFeePercentage } = subproperty

      return !(isNil(paymentsEnabled) || isNil(owqloFeeFixed) || isNil(owqloFeePercentage))
    },
  },
  mounted() {
    if (!this.walletEnabled) this.goToHome()
  },
  methods: {
    goToHome() {
      this.$router.push({ name: 'home' })
    },
  },
};
